import React, { PureComponent } from 'react';
import classNames from 'classnames';
import { withTranslation } from 'react-i18next';
import baseStyles from '../styles';

import { Dialog, DialogTitle, DialogContent, Tabs, Tab } from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import { isMobileDevice } from '../../helpers/mobile';

import SlotDialog from './SlotDialog';
import AddEventForm from './AddEventForm';

class AddEventDiaog extends PureComponent {
  state = {
    tab: 0,
    isConfirmDlgOpen: false,
    slotData: '',
    formValues: null,
  };

  handleTabChange = (e, tab) => {
    this.setState({ tab });
  };
  handleGenerateSlot = async (values, formValues) => {
    const { onGenerateSlots } = this.props;
    try {
      const slots = await onGenerateSlots(values);
      this.setState({ tab: 1, slotData: slots.slot, formValues });
    } catch (err) {}
  };

  handleClose = () => {
    const { onClose } = this.props;
    this.setState({ slotData: '', formValues: null });
    onClose();
  };

  render() {
    const { airports, classes, isOpen, onClose, onSubmit, t } = this.props;
    const { tab } = this.state;
    const isSmallWidth = isMobileDevice();
    return (
      <Dialog
        classes={{
          paperWidthLg: classes.dialog,
        }}
        open={isOpen}
        fullWidth
        maxWidth="lg"
        fullScreen={isSmallWidth}
        onClose={onClose}
      >
        <DialogTitle>
          <Tabs
            value={tab}
            indicatorColor="primary"
            textColor="primary"
            variant="fullWidth"
            onChange={this.handleTabChange}
          >
            {!isSmallWidth && <Tab label={t('form')} />}
            <Tab label={t('slot')} />
          </Tabs>
        </DialogTitle>
        <DialogContent
          className={classNames(classes.noPadding, classes.noOverflowX)}
        >
          {tab === 0 && !isSmallWidth && (
            <AddEventForm
              airports={airports}
              onClose={this.handleClose}
              onSubmit={this.handleGenerateSlot}
              formValues={this.state.formValues}
            />
          )}
          {(tab === 1 || isSmallWidth) && (
            <SlotDialog
              slotData={this.state.slotData}
              onClose={this.handleClose}
              onSubmit={onSubmit}
            />
          )}
        </DialogContent>
      </Dialog>
    );
  }
}

const styles = theme => ({
  ...baseStyles(theme),
  dialog: {
    maxWidth: '1150px',
  },
});

export default withTranslation()(withStyles(styles)(AddEventDiaog));
